import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { io } from "socket.io-client";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class SocketService {
  public socket: any;

  // setup socket
  setupSocketConnection(): void {
    const userToken: any = localStorage.getItem("userToken");
    const socketURL = environment.SOCKET_URL; // Corrected the typo in the URL
    this.socket = io(socketURL, {
      transports: ["websocket", "polling"],
      auth: {
        authorization: userToken
      }
    });
  }

  /** @deprecated use listener insted of listen*/
  listen = (eventName: string): Observable<any> => {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data: any) => {
        subscriber.next(data);
      });
    });
  };

  listener = (eventName: string): Observable<any> => {
    return new Observable((subscriber) => {
      const handler = (data: any): void => subscriber.next(data);
      this.socket.on(eventName, handler);
      return () => this.socket.off(eventName, handler);
    });
  };

  emit = (eventName: any, data: any): void => {
    this.socket.emit(eventName, data);
  };

  removeListener = (eventName: any, data: any): void => {
    this.socket.removeListener(eventName, data);
  };

  connectRoom = (roomId: any): void => {
    this.socket.emit("room", roomId);
  };

  disconnetRoom = (roomId: any): void => {
    this.socket.emit("removeRoom", roomId);
  };

  disconnectSocket = (eventName: any): void => {
    this.socket.off(eventName);
  };

  sendAndListenEvent(event: string, data: any, callback: (responseData: any) => void): void {
    // Emit the event and receive the acknowledgment
    this.socket.emit(event, data, (response: any) => {
      callback(response);
    });
  }

  connectSocket(completion: (isConnected: boolean) => void): void {
    this.socket.on("connect", () => {
      completion(true);
    });
    this.socket.connect();
  }
}
